import { Box, Grid, makeStyles } from "@material-ui/core";
import React from "react";
import DaikukoContainer from "../../component/DaikukoContainer";
import Footer from "../../component/Footer";
import NavigationBar from "../../component/NavigationBar";
import ItemBackground from "./ItemBackground";
import MainContent from "./MainContent";
import MobileItem from "./mobile/MobileItem";

import Sidebar from "./Sidebar";
// import itemsFullData from "./veggies/ItemsFullData";

const useStyles = makeStyles((theme) => ({
  itemsContainer: {
    height: "auto",
    minHeight: "100vh",
    position: "relative",
    [theme.breakpoints.between("md", "md")]: {
      height: "100vh",
    },
  },

  gridBox: {
    height: "1025px",
    maxHeight: "1025px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.between("lm", "lm")]: {
      height: "auto",
    },
    [theme.breakpoints.between("md", "md")]: {
      height: "auto",
    },
  },
  gridItem: {
    height: "inherit",
    maxHeight: "inherit",
  },
}));
//TODO Add Accordion
export default function Items(props) {
  const classes = useStyles();
  const {
    veggieData,
    title,
    onClickChangeVeggieData,
    onClickMobile,
    veggieItem,
  } = props;

  return (
    <Box className={classes.itemsContainer}>
      <NavigationBar />
      <ItemBackground />
      <DaikukoContainer title="取扱商品一覧" maxWidth="lg">
        <Grid className={classes.gridBox} container spacing={4}>
          <Grid item md={3} xs={12}>
            <Sidebar
              veggieItem={veggieItem}
              setVeggieItem={onClickChangeVeggieData}
            />
          </Grid>
          <Grid item md={9} xs={12} className={classes.gridItem}>
            <MainContent title={title} vegData={veggieData.categories} />
          </Grid>
        </Grid>

        <MobileItem
          veggieItem={veggieItem}
          setVeggieItem={onClickMobile}
          vegData={veggieData.categories}
        />
      </DaikukoContainer>
      <Footer />
    </Box>
  );
}
